import { useEffect, useRef } from 'react';

// Bắn callback đúng 1 lần khi element hiện >= threshold trong viewport.
// Impression convention theo spec MKT: 50% card visible.
// `enabled`: chỉ observe (và tiêu lượt bắn) khi true — tránh mất impression
// khi data đến trễ (vd. isHighProfit chỉ true sau khi refetch).
export default function useOnceInViewport(onVisible, threshold = 0.5, enabled = true) {
  const targetRef = useRef(null);
  const firedRef = useRef(false);
  const onVisibleRef = useRef(onVisible);
  onVisibleRef.current = onVisible;

  useEffect(() => {
    const el = targetRef.current;
    if (!enabled || !el || firedRef.current) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !firedRef.current) {
          firedRef.current = true;
          onVisibleRef.current?.();
          observer.unobserve(el);
        }
      },
      { threshold },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, enabled]);

  return targetRef;
}
